'use strict';
const _ = require('underscore');
module.exports = function scene(sceneMap) {
	if (!sceneMap) {
		return undefined;
	}
	sceneMap.matchesScene = function (anotherScene) {
		if (!sceneMap || !anotherScene) {
			return false;
		}
		if (sceneMap.ideaId != anotherScene.ideaId) { //eslint-disable-line eqeqeq
			return false;
		}
		if (sceneMap.index !== anotherScene.index) {
			return false;
		}
		return true;
	};
	sceneMap.clone = function () {
		return scene(_.extend({}, sceneMap));
	};
	return sceneMap;
};

